import React, { forwardRef, useMemo, useCallback } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import JfrogXrayMappingForm from './JfrogXrayMappingForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import JfrogXrayMappingFormV2 from './JfrogXrayMappingFormV2';


function  JfrogXrayCredentialForm(props, ref){
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator],
        },
        {
            name: "token",
            label: "Token",
            type: FieldTypes.PASSWORD,
            required: true
        },...(featureFlags.MANAGE_SBOM ? [{
                            name: "ingestSBOM",
                            label: "Ingest Components",
                            type: FieldTypes.SWITCH,
                            help: 'Ingest all components from the projects mapped under this configuration into the Supply Chain module',
                            inline: true,
                          }] : []),]
        ),[featureFlags.MANAGE_SBOM])

    const parseExtraFields = useCallback((config) => {
                return {
                    ...config,
                    ingestSBOM : config.ingestSBOM === "true"
                };
            }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={featureFlags.JFROG_XRAY_FETCH_REPOSITORY ? JfrogXrayMappingFormV2 : JfrogXrayMappingForm}
            initialValue={{ingestSBOM: false}}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(JfrogXrayCredentialForm);